import { StepType } from '@crm/types'
import { TipTapEditor } from '@shared/components/TipTapEditor'
import { useLocales } from '@shared/locales'
import { Col, Form, FormInstance, Input, Row } from 'antd'
import * as React from 'react'

interface DynamicFormProps {
  form: FormInstance<unknown>
  step_type?: string
}

export const DynamicForm = ({ step_type, form }: DynamicFormProps) => {
  const { t } = useLocales()

  const onRenderFields = React.useMemo(() => {
    if (step_type === StepType.GMAIL || step_type === StepType.OUTLOOK) {
      return (
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item
              name="email_subject"
              label={t('campaigns.email_subject')}
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="email_message"
              label={t('campaigns.email_message')}
              rules={[{ required: true }]}
            >
              <TipTapEditor />
            </Form.Item>
          </Col>
        </Row>
      )
    }

    return <></>
  }, [step_type, form])

  return <div>{onRenderFields}</div>
}
